import { READING_RANK } from "lib/const";
import moment from "moment";
import { useRef } from "react";
import ReactToPrint from "react-to-print-advanced";



export const CertificateView = ({ appleCertificate }) => {
    const myCertificate = useRef();

    console.log(appleCertificate);

    let date = `${appleCertificate.year}년 12월 31일`;
    if (appleCertificate.year === moment().format("YYYY")) {
        date = moment().format('YYYY년 MM월 DD일');
    }


    let rank = READING_RANK.find((rank) => rank.startNum <= appleCertificate.totalCount);


    return (
        <div className="print_viewer" style={{ display: 'block' }} key="report_print">
            <div className="alignR">
                <ReactToPrint copyStyles={true}
                    pageStyle=""
                    trigger={() => <button className="btn _red mgB10" ><i className="fas fa-print"></i> 출력</button>}
                    content={() => myCertificate.current} />
            </div>
            <div className="report_page_wrap certificatePageContainer">
                <div className={`certificatePage report_page ${rank.rank}`} ref={myCertificate}>
                    <div className="user">
                        {appleCertificate?.user?.schoolName}<br />
                        {`${appleCertificate.grade}학년 ${appleCertificate.schoolClass}반 ${appleCertificate?.user?.name}`}
                    </div>
                    <div className="content">
                        &nbsp;  위 어린이는 <span className="year">{appleCertificate.year}</span>년 독서길라잡이에 참여하여 꾸준한 독서활동으로 <span className="rankName">'{rank.name}'</span>를 달성 하였기에 이 상장을 드립니다.
                    </div>

                    <div className="date">{date}</div>

                    <div className="supplier">
                        <strong>독서길라잡이</strong>
                        <img src={`${process.env.PUBLIC_URL}/static/images/certificate/cert_stamp.png`} className="stamp" alt={rank.name} />
                    </div>
                    <img src={`${process.env.PUBLIC_URL}/static/images/certificate/certificate_bg0${(rank.rank < 1) ? '' : rank.rank}.jpg`} className="background" alt="배경" />
                </div>
            </div>
        </div>
    );

};